import { Action } from 'redux'
import { InvoiceActions } from '../../reducers/invoice/actionNames'

const createInvoiceFromForm = (reference): ICreateInvoiceFromForm => ({
  reference,
  type: InvoiceActions.CreateFromForm,
})
const createInvoice = (id: string): ICreateInvoice => ({
  id,
  type: InvoiceActions.Create,
})

export interface ICreateInvoice extends Action<InvoiceActions.Create> {
  id: string
}

export interface ICreateInvoiceFromForm
  extends Action<InvoiceActions.CreateFromForm> {
  reference?: any
}

export { createInvoice, createInvoiceFromForm }
